// Dependencies
require('fullpage.js/vendors/scrolloverflow');
require('../../../vendors/fullpage.parallax.min.js');
var fullpage = require('fullpage.js/dist/fullpage.extensions.min');
require('fullpage.js/vendors/easings');

// Timeline Module
import OverlayScrollbars from "overlayscrollbars";
import { timeline } from "./modules/timeline";

// Section Modules
import { pageHeroBanner } from "../lib/pageHeroBanner";
import { textImage } from "../lib/textImage";
import { helper } from "../lib/helper";

// Required modules
require("./modules/bottle_slider");
require("./modules/full_thumbnail_slider");

// Fullpage plugin
var History;

helper.appendFooter();
helper.removeClasser();

History = {
  init() {

    //Navigation
    var navList = [];
    var sectionLength = $('.section').length;

    var fullPageNav = $('.js-fullPage-nav');
    var navHTML = '';
    var isMobileStatus = (document.getElementById('history').classList.contains('is-mobile')) ? '' : '.js-section-timeline';

    for (let i = 0; i < sectionLength; i++) {
      navList.push('parallax-' + i);
      navHTML = '<a class="fullPage-nav-links" data-menuanchor="parallax-' + i + '"  href="#parallax-' + i + '"></a>';
      fullPageNav.append(navHTML);
    }

    let historyFullpage = new fullpage('#history', {
      // Key
      licenseKey: 'E02B3FBDB98847A6A2FE0582C69F6DC7',

      // Parallax
      parallax: true,
      parallaxKey: 'bW9sbGVycy5jb21fRUFXY0dGeVlXeHNZWGc9NU1B',
      parallaxOptions: { type: 'cover', percentage: 50, property: 'background' },

      // Easing
      css3: true,
      easingcss3: 'cubic-bezier(0.645, 0.045, 0.1, 1)',

      // Scrolling
      scrollingSpeed: 1000,
      fitToSectionDelay: 1000,
      autoScrolling: true,
      scrollOverflow: true,
      normalScrollElements: isMobileStatus,
      scrollOverflowReset: true,
      scrollOverflowOptions: {
        scrollbars: false,
      },

      // Dots
      // navigation: true,
      // navigationPosition: 'right',
      // anchors: navList,
      // slidesNavigation: true,
      // menu: '#parallax-nav',
      anchors: (document.getElementById('history').classList.contains('is-mobile')) ? [] : navList,
      slideNavigation: (document.getElementById('history').classList.contains('is-mobile')) ? false : true,
      menu: '#parallax-nav',

      // events
      onLeave(origin, destination, direction) {

        pageHeroBanner.init(origin, destination, direction, 'onLeave');
        textImage.init(destination);

        // Special case js
        $('.js-btn-scroll, #fp-nav>ul').addClass('navFade'); // <- adds fade effect on navs

        // <- Match up with the plugins scrollingSpeed
        setTimeout(() => {
          $(origin.item).find('.animated').removeClass('js-animate-completed');
          $(destination.item).find('.animated').addClass('js-animate-completed');
        }, 300);

        helper.scrollIconCtrl(origin, destination, direction);

      },

      afterLoad(origin, destination, direction) {
        // let sections = $('.section');
        // sections.css('height', ( parseInt(sections.css('height')) - parseInt($('.navbar').css('height')) ));

        pageHeroBanner.init(origin, destination, direction, 'afterLoad');

        // <- Match up with the plugins scrollingSpeed
        setTimeout(() => {
          $('.js-btn-scroll, #fp-nav>ul').removeClass('navFade'); // <- adds fade effect on navs
          $(destination.item).hasClass('fp-completely') ? $(destination.item).find('.animated').addClass('js-animate-completed') : '';
        }, 1000);

        if ($(destination.item).hasClass('js-section-timeline')) {
          if (!document.body.classList.contains('ipad')) {
            fullpage_api.setAllowScrolling(false);
          }
        }

        if(destination.item.classList.contains('js-append-footer')) {
          helper.observer(destination.index);
          let counter = 0;
          $(window).on('mousewheel DOMMouseScroll', function(event){
            if(destination.item.classList.contains('js-append-footer')) {
              helper.observer(destination.index);
              let deltaY = event.originalEvent.wheelDelta;
              let detailY = event.originalEvent.detail;
              if(deltaY === 120) {
                if($('.js-append-footer .fp-scroller').css('transform') == 'matrix(1, 0, 0, 1, 0, 0)') {
                  // fullpage_api.moveTo(destination.index);
                  counter++;
                  if(counter > 1 && counter < 2) {
                    window.requestAnimationFrame(function () { fullpage_api.moveSectionUp() });
                  }
                  // fullpage_api.moveSectionUp();
                  fullpage_api.setAllowScrolling(true);
                }
              }
            }
          });
        } else {
          fullpage_api.setAllowScrolling(true);
        }

        var nav = document.getElementById('js-head');
        var body = document.getElementsByTagName('body')[0];

        body.classList.add('is-fullpage');

        if (direction == 'down') {
          nav.classList.add('slideUp');
          nav.classList.remove('slideDown');
        } else {
          nav.classList.add('slideDown');
          nav.classList.remove('slideUp');
        }
      },
    });

    // $(window).innerWidth() <= 979.98 ? fullpage_api.setAutoScrolling(false) : fullpage_api.setAutoScrolling(true);

    fullpage_api.setAutoScrolling(true);
    fullpage_api.setFitToSection(false);
    fullpage_api.setAllowScrolling(true);
    fullpage_api.parallax.init();
  },
  mobile() {
    new fullpage('#history', {
      // Key
      licenseKey: 'E02B3FBDB98847A6A2FE0582C69F6DC7',
      parallax: true,
      parallaxKey: 'bW9sbGVycy5jb21fRUFXY0dGeVlXeHNZWGc9NU1B',
      autoScrolling: false,
      css3: true,
      easingcss3: 'linear',
      scrollOverflow: true,
      touchSensitivity: 15,
      parallaxOptions: { type: 'cover', percentage: 20, property: 'translate' },
    });

    //changing the value for the property `type`
    // fullpage_api.parallax.setOption('type', 'cover');
    //changing the value for the property `percentage`
    // fullpage_api.parallax.setOption({
    //   type: 'cover',
    //   percentage: '30',
    // });
    fullpage_api.parallax.init();
  },
  bannerBgMobile() {
    if ($(window).innerWidth() <= 979.98) {

      $('.js-full-banner').css({
        'background-image': `url(${$('.js-full-banner').data('bg')})`
      });

    } else {
      $('.js-full-banner').css({
        'background-image': ``
      });
    }
  }
}

$(function () {
  History.init();
  timeline.init();
  History.bannerBgMobile();

  $(window).resize(function () {
    timeline.init();
    History.bannerBgMobile();
  });
});



// WEBPACK FOOTER //
// ./scripts/components/featured/history/index.js